"use client"
import React, { Fragment } from "react"
import { Typography } from "antd"
import { getAllListings } from "@lib/api/listings"
import styles from "@css/modules/Listings.module.scss"
import { fetchUserSearches, saveUserSearches, updateUserSearches } from "@lib/api/user"
import { log } from "@utils/logger"
import { addLikes } from "@components/Listings/listings-page-utils"
import { filtersState } from "@utils/FiltersState"
import { ListingsContainer } from "@components/Listings/ListingsContainer"
import { SaveSearchBtn } from "@components/Listings/SearchesButtons/SaveSearchBtn"
import { SavedSearchesDropDown } from "@components/Listings/SearchesButtons/SaveSearchDropDown"
import { observer } from "@utils/observer"
import cn from "classnames"
import { Filter } from "@css/icons/SVG"
import { Intersection } from "@components/Intersection/Intersection"
import { SortBtn } from "@components/Listings/SortBtn"
import { SignInWithGoogle } from "@components/SignInWithGoogle"
import { FiltersCount } from "@components/Listings/ListingsFilter/components/FiltersCount"
import { listingsState } from "@utils/listings-state"
import { store } from "@utils/store"
import { withRouter } from "@utils/hoc/withRouter"
import ListingsFilter from "@components/Listings/ListingsFilter/ListingsFilter"
import { openModal } from "@components/Layout/components/LoginModal"
import { ListingInRowAd } from "@components/Listings/ListingInRowAd"
import { ListingHeaderAd } from "@components/Listings/ListingHeaderAd"
import { ListingItem, ListingItemSkeleton } from "@components/Listings/ListingItem"
import { ListingItemsHeader } from "@components/Listings/ListingItemsHeader"
import { message } from "@components/Message/message"

const { Title } = Typography

let lastWhere = {}
let scrollPosition = {}
class ListingsPage extends React.Component {
    constructor(props) {
        super(props)
        const sort = filtersState.getSort(props.pathname) || {}
        this.stateMirror = {
            where: {},
            sort: sort.value,
            total: props.meta.pagination.total,
            page: props.meta.pagination.page,
            listings: props.listings,
            ...listingsState.state?.[props.pathname],
            loading: false,
            loadingMore: false
        }
        this.state = {
            update: 1
        }
    }
    componentWillMount() {
        if (!scrollPosition[this.props.pathname] && typeof window !== "undefined") {
            window.scroll(0, 0)
        }
    }

    componentWillUnmount() {
        listingsState.state[this.props.pathname] = this.stateMirror
        lastWhere[this.props.pathname] = JSON.stringify(this.stateMirror.where)
        scrollPosition[this.props.pathname] = window.scrollY
    }

    onLoadMore = (active) => {
        const { loadingMore, total, listings } = this.stateMirror
        if (active && !loadingMore && total > listings.length) {
            this.loadMore()
        }
    }

    setUpdateTime = () => {
        this.setState({
            update: this.state.update + 1
        })
    }
    setData = (newData) => {
        this.stateMirror = {
            ...this.stateMirror,
            ...newData
        }
        this.setUpdateTime()
    }
    loadMore = () => {
        this.setData({
            loadingMore: true
        })
        getAllListings({
            page: this.stateMirror.page + 1,
            pageSize: this.limit,
            sort: this.stateMirror.sort,
            where: { ...this.stateMirror.where }
        }).then(({ listings: { data, meta } }) => {
            const listings = JSON.parse(JSON.stringify(this.stateMirror.listings))
            const newListings = addLikes(data || [])
            newListings.forEach((l) => {
                const listingExists = listings.findIndex((o) => o.id === l.id)
                if (listingExists > -1) {
                    console.error("listings duplicates found", l.id)
                    listings[listingExists] = l
                } else {
                    listings.push(l)
                }
            })
            this.setData({
                total: meta.pagination.total,
                page: meta.pagination.page,
                listings,
                loadingMore: false
            })
        })
    }

    initialChange = true
    onChange = (where) => {
        clearTimeout(this.changeTimeout)
        this.changeTimeout = setTimeout(() => {
            if (this.initialChange) {
                this.initialChange = false
                const path = this.props.pathname
                if (this.stateMirror.listings?.length && JSON.stringify(where) === lastWhere[path]) {
                    if (store.get(store.k.routeMethod) === "POP") {
                        window.scrollTo({
                            top: scrollPosition[path],
                            behavior: "instant"
                        })
                    }
                    setTimeout(() => {
                        scrollPosition[path] = 0
                    }, 1000)
                    return
                }
            }
            this.setData({
                loading: true,
                page: 1,
                where
            })
            getAllListings({
                page: 1,
                pageSize: this.limit,
                where,
                sort: this.stateMirror.sort
            }).then(({ listings: { data: listings, meta } }) => {
                this.setData({
                    loading: false,
                    total: meta.pagination.total,
                    page: meta.pagination.page,
                    listings: addLikes(listings || [])
                })
            })
        }, 300)
    }

    onSaveFilters = async ({ name, created_at, should_notify, frequency } = {}, username) => {
        const search_query = {
            where: {
                ...this.stateMirror.where
            },
            sort: this.stateMirror.sort
        }
        const body = {
            name,
            frequency,
            created_at,
            should_notify,
            search_query
        }
        if (!username) {
            localStorage.setItem(
                "savedSearchBeforeLogin",
                JSON.stringify({
                    body,
                    date: Date.now() + 1000 * 60 * 15 // 15 minutes
                })
            )
            openModal()
            return Promise.resolve()
        }
        try {
            if (created_at) {
                await updateUserSearches(body)
                await fetchUserSearches()
            } else {
                const resp = await saveUserSearches(body)
                await fetchUserSearches()
                this.props.changeFilter(resp?.data?.created_at)
            }
        } catch (err) {
            log(err)
            message.error(err?.toString())
        }
    }
    onTableChange = (sorter) => {
        let { columnKey, order } = sorter
        if (columnKey === "resort") {
            columnKey = "resort.short_name"
        }
        let sort = undefined
        if (order) {
            const direction = order === "ascend" ? "asc" : "desc"
            sort = `${columnKey}:${direction}`
            filtersState.setSort(
                {
                    value: sort,
                    column: columnKey,
                    order
                },
                this.props.pathname
            )
        } else {
            filtersState.setSort({}, this.props.pathname)
        }
        this.stateMirror.sort = sort
        this.onChange(this.stateMirror.where)
    }

    headerSort = (e) => {
        const columnKey = e.target.dataset.field
        const initialSort = e.target.dataset.sort || "ascend"
        const secondSort = initialSort === "ascend" ? "descend" : "ascend"
        const currentSort = filtersState.getSort(this.props.pathname)
        const sameColumn = columnKey === currentSort?.column
        this.onTableChange({
            columnKey,
            order: sameColumn ? (currentSort.order === initialSort ? secondSort : initialSort) : initialSort
        })
    }

    renderListings = () => {
        const stateMirror = this.stateMirror
        const sort = filtersState.getSort(this.props.pathname)
        const listingAd = this.props.listingAd
        return (
            <div className={styles.cardContainer}>
                <ListingItemsHeader onTableChange={this.onTableChange} resort={this.props.resort} sort={sort} headerSort={this.headerSort} />
                {stateMirror.listings.map((i, index) => {
                    if (listingAd && listingAd.displayAtPosition.includes(index.toString())) {
                        return (
                            <Fragment key={i.id}>
                                <ListingInRowAd listingAd={listingAd} />
                                <ListingItem listing={i} />
                            </Fragment>
                        )
                    }
                    return <ListingItem listing={i} key={i.id} />
                })}
                {stateMirror.loadingMore &&
                    Array(20)
                        .fill(0)
                        .map((_, i) => <ListingItemSkeleton key={i} />)}
                <Intersection onChange={this.onLoadMore} className={styles.cardContainerIntersection} rootMargin="800px 0px 800px 0px" />
            </div>
        )
    }

    renderHeader = () => {
        const stateMirror = this.stateMirror
        const total = <div className={styles.total}>{stateMirror.total} results found</div>
        const resortPage = !!this.props.resort
        const savedSearches = !resortPage && <SavedSearchesDropDown />
        const searchBtn = !resortPage && <SaveSearchBtn onSaveFilters={this.onSaveFilters} where={this.stateMirror.where} />
        const listingAd = this.props.listingAd
        return (
            <>
                <div className={cn(styles.headerText, listingAd && styles.headerTextWithAd)}>
                    <div className={styles.limitContent}>
                        <Title>{this.props.title}</Title>
                        {this.props.description}
                    </div>
                    <ListingHeaderAd listingAd={listingAd} />
                </div>
                <div className={styles.buttons}>
                    <button onClick={() => observer.trigger("listingsFilterOpen")} className={styles.filtersBtn}>
                        <FiltersCount filters={this.stateMirror.where} />
                        <Filter className={styles.filterIcon} />
                    </button>
                    <SortBtn resortSorting={resortPage} text="Sort" onChange={this.onTableChange} sort={filtersState.getSort(this.props.pathname)} placement="bottom" />
                    {total}
                    {searchBtn}
                    {savedSearches}
                </div>
            </>
        )
    }

    limit = 20

    render() {
        const { filterData, resort, loading, breadcrumb, pathname } = this.props
        return (
            <div className={cn(styles.root)}>
                <ListingsFilter pathname={pathname} loading={loading} resort={resort?.id} filterData={filterData} onChange={this.onChange} total={this.stateMirror.total} />
                <div className={styles.content}>
                    {breadcrumb}
                    {this.renderHeader()}
                    {this.renderListings()}
                </div>
                <SignInWithGoogle />
            </div>
        )
    }
}

export const Page = withRouter(ListingsContainer(ListingsPage))
